import { useTranslation } from 'react-i18next';
import LoadingButton from '@shared/components/LoadingButton';

export default function DocumentNumberChange({ contractNo, setContractNo, handleSaveContractNo, loading, editingContractId, selectedContractId, setOverlayView }) {
    const { t } = useTranslation();
    return (
        <>
            <div className="flex-column">
                <h3 className="form-subtitle"> {t('persons.personContract.changeDocumentNumberTitle')}</h3>
                <div className="flex-row justify-content-center">
                    <span>{t('persons.personContract.documentNumber')}</span>
                    <input
                        type="text"
                        className="small-input"
                        style={{ width: '100px' }}
                        value={contractNo}
                        onChange={(e) => setContractNo(e.target.value)}
                    />
                </div>
                <div className="form-controls">
                    <LoadingButton
                        loading={loading}
                        type="button"
                        className="form-btn btn-blue"
                        onClick={handleSaveContractNo}
                        disabled={!(editingContractId || selectedContractId)}
                    >
                        {t('common.save') || 'Save'}
                    </LoadingButton>
                    <button
                        type="button"
                        className="form-btn btn-red"
                        onClick={() => setOverlayView(null)}
                        title={t('common.exit') || 'Exit'}
                    >
                        {t('common.exit') || 'Exit'}
                    </button>
                </div>
            </div>
        </>
    );
}